<ng-container *ngIf="reviewsData.totalItems !== null && reviewsData.totalItems > 0">
<div class="max-w-2xl mx-auto pt-16 sm:pt-24 px-4 sm:px-6 lg:px-8 lg:max-w-7xl" id='reviews'>
    <kb-section-header color="galliano">Customer Reviews</kb-section-header>
</div>
<div
    class="max-w-2xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-12 lg:gap-x-8"
>
    <div class="lg:col-span-4">
        <kb-product-review-rating-large
            class="block mt-2"
            *ngIf="rating != null"
            [rating]="rating"
            [reviewCount]="reviewsData.totalItems"
        ></kb-product-review-rating-large>

        <div class="mt-4">
            <h3 class="sr-only">Review data</h3>
            <kb-product-review-histogram
                [binData]="histogramData"
                [displayFilters]="false"
            ></kb-product-review-histogram>
        </div>

        <div class="mt-10">
            <h3 class="text-lg font-medium text-gray-900">Share your thoughts</h3>
            <p class="mt-1 text-sm text-gray-600">
                If you’ve used this product, share your thoughts with other customers
            </p>

            <a
                href="#"
                class="btn btn-neutral mt-6 inline-flex w-full sm:w-auto lg:w-full"
                [routerLink]="['./', 'reviews', 'submit']"
                >Write a review</a
            >
        </div>
    </div>

    <div class="mt-16 lg:mt-0 lg:col-start-6 lg:col-span-7">
        <h3 class="sr-only">Recent reviews</h3>
        <kb-product-review-list [reviews]="reviewsData.items"></kb-product-review-list>
        <a class="btn" [routerLink]="['./reviews']" *ngIf="reviewsData.items.length < reviewsData.totalItems">
            View all {{ reviewsData.totalItems }} reviews
        </a>
        <ng-template *ngIf="reviewsData.totalItems === 0">
            <div
                class="flex flex-col items-center justify-center space-y-4 h-full border-2 border-dashed rounded-lg"
            >
                <fa-icon [icon]="star" size="3x" class="text-gray-200"></fa-icon>
                <div class="text-2xl text-gray-400 text-center">This product hasn't been reviewed yet</div>
            </div>
        </ng-template>
    </div>
</div>
</ng-container>
